import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TeamService {

  private baseUrl:string = `${environment.legalAssureApiBaseUrl}`;

  constructor(private httpClient:HttpClient) { }

  createTeams(request:any){
    return this.httpClient.post<any[]>(this.baseUrl+'team',request);
  }

  getAllTeams(): Observable<any> {
   let headersOptions = new HttpHeaders();
   headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.get<any>(this.baseUrl+'team',{headers:headersOptions});
  }

  deleteById(data:any){
    return this.httpClient.delete<any[]>(this.baseUrl+`team/${data}`);
  }

  getById(data:any){
    return this.httpClient.get<any>(this.baseUrl+`team/${data}`);
  }
  getByName(data:any){
    return this.httpClient.get<any>(this.baseUrl+`team/teamByName/${data}`);
  }
  update(request:any){
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put<any[]>(this.baseUrl+'team',request);
  }

}
